const AddTeacherDrawerSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 w-full animate-pulse mt-4">
      {/* Name Input */}
      <div className="flex flex-col gap-2">
        <div className="w-24 h-4 bg-neutral-200 rounded " />
        <div className="w-full h-10 bg-neutral-200 rounded-md " />
      </div>

      {/* Email Input */}
      <div className="flex flex-col gap-2">
        <div className="w-24 h-4 bg-neutral-200 rounded " />
        <div className="w-full h-10 bg-neutral-200 rounded-md " />
      </div>

      {/* Phone Input */}
      <div className="flex flex-col gap-2">
        <div className="w-24 h-4 bg-neutral-200 rounded " />
        <div className="flex gap-2">
          <div className="w-20 h-10 bg-neutral-200 rounded-md " />
          <div className="flex-1 h-10 bg-neutral-200 rounded-md " />
        </div>
      </div>

      {/* Assign Class Select */}
      <div className="flex flex-col gap-2">
        <div className="w-32 h-4 bg-neutral-200 rounded " />
        <div className="w-full h-10 bg-neutral-200 rounded-md " />
      </div>

      {/* Send Credentials Switch */}
      <div className="flex items-center gap-3 mt-2">
        <div className="w-10 h-6 bg-neutral-200 rounded-full " />
        <div className="w-40 h-4 bg-neutral-200 rounded " />
      </div>
    </div>
  );
};

export default AddTeacherDrawerSkeleton;
